export const getPageHref = (page: string, params?: Record<string, string>, hash?: string) => {
    const newUrl = new URL(page, window.location.origin);

    for (const param in params) {
        newUrl.searchParams.set(param, params[param] || '');
    }

    if (hash) {
        newUrl.hash = hash;
    }

    return newUrl.href;
};
